import { defineStore } from 'pinia'

export const useSearchStore = defineStore('search', {
  state: () => ({
    query: ''
  }),
  getters: {
    normalizedQuery: (state) => state.query.trim().toLowerCase(),
    hasSearchContent: (state) => !!state.query.trim()
  },
  actions: {
    setQuery(newQuery: string) {
      this.query = newQuery
    }
  }
})
